import React from 'react';

import { LinearProgress } from '@material-ui/core';
import { default as EditIcon } from '@material-ui/icons/Edit';

import { resetMode } from '../../../../../../../../state/ui/devices';
import { usePrivileges } from '../../../../../../../../state/auth/index.hooks';
import {
    useDevicesLoading,
    useSelectedDevice,
    useSelectedDeviceAsReports,
} from '../../../../../../../../state/ui/devices/index.hooks';

import IconButtonWithTooltip from '../../../../../../../../components/IconButtonWithTooltip';
import PaneHeader from '../../../../../../../../components/PaneHeader/PaneHeader';
import ReportPreview from '../../../../../../../../components/report/ReportPreview';
import TranslationHelper from '../../../../../../../../helpers/TranslationHelper';
import {
    useAppDispatch,
    useToolkitDispatch,
} from '../../../../../../../../hooks';
import { showDeviceDialog } from '@/app/state/ui/dialog';

const DevicesPreview = () => {
    const toolkitDispatch = useToolkitDispatch();
    const dispatch = useAppDispatch();
    const privileges = usePrivileges();
    const loading = useDevicesLoading();
    const device = useSelectedDevice();
    const deviceReports = useSelectedDeviceAsReports();

    const handleEnterEditMode = () =>
        device && dispatch(showDeviceDialog({ mode: 'edit', device }));

    const handleCloseClick = () => {
        toolkitDispatch(resetMode());
    };

    const getRightCustomControls = () => (
        <IconButtonWithTooltip
            title={TranslationHelper.translate('Edit device')}
            onClick={handleEnterEditMode}
        >
            <EditIcon />
        </IconButtonWithTooltip>
    );

    return (
        <div>
            <PaneHeader
                onCloseClick={handleCloseClick}
                title={`${TranslationHelper.translate('Device details')}: ${
                    device?.name || device?.serialNumber || ''
                }`}
                renderRightCustomControls={
                    privileges.eToll ||
                    privileges.eTollEditRegistrationData ||
                    privileges.editDevices
                        ? () => getRightCustomControls()
                        : undefined
                }
            />
            {device && !loading ? (
                <>
                    <ReportPreview reports={deviceReports} />
                </>
            ) : (
                <LinearProgress />
            )}
        </div>
    );
};

export default DevicesPreview;
